module.exports = __webpack_public_path__ + "img/img (35).e10c4dc5.jpg";